function hasCheckoutParameter() {
  const urlParams = new URLSearchParams(window.location.search);
  const checkoutUrl = urlParams.get('checkout_url');
  
  // Check for various checkout indicators
  const hasCheckoutParam = urlParams.has('checkout');
  const hasCheckoutPath = window.location.pathname.includes('checkouts');
  const hasValidCheckoutUrl = checkoutUrl && checkoutUrl !== '/' && checkoutUrl.trim() !== '';
  
  return hasCheckoutParam || hasCheckoutPath || hasValidCheckoutUrl;
}

// Toggle between different forms
function toggleForm(targetFormId) {
  const forms = ['login-form', 'register-form', 'recover-form'];
  
  forms.forEach(formId => {
    const formElement = document.getElementById(formId);
    if (formElement) {
      if (formId === targetFormId) {
        // Show the target form
        formElement.style.display = "block";
        formElement.classList.remove('hide');
        formElement.setAttribute('aria-hidden', 'false');
      } else {
        // Hide other forms
        formElement.style.display = "none";
        formElement.classList.add('hide');
        formElement.setAttribute('aria-hidden', 'true');
      }
    }
  });
}

// Initialize toggle event listeners
function initializeToggleListeners() {
  const toggleButtons = document.querySelectorAll('[data-toggle]');
  
  toggleButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      const targetFormId = this.getAttribute('aria-controls');
      if (targetFormId) {
        toggleForm(targetFormId);
      }
    });
  });
}

// Hide or show all forms based on checkout parameter
function hideAllForms() {
  const forms = ['login-form', 'register-form', 'recover-form'];
  forms.forEach(formId => {
    const formElement = document.getElementById(formId);
    if (formElement) {
      formElement.style.display = "none";
      formElement.classList.add('hide');
      formElement.setAttribute('aria-hidden', 'true');
    }
  });
}

function showAllForms() {
  const forms = ['login-form', 'register-form', 'recover-form'];
  forms.forEach(formId => {
    const formElement = document.getElementById(formId);
    if (formElement) {
      // Make forms available but don't show them all at once
      formElement.style.display = "none"; // Keep hidden initially
      formElement.classList.add('hide');
      formElement.setAttribute('aria-hidden', 'true');
    }
  });
  
  // Show create account form by default when checkout parameter exists
  toggleForm('register-form');
  
  // Set checkout URL in forms
  setCheckoutUrl();
}

// Initialize the page behavior based on checkout parameter
function initializeLoginBehavior() {
  const createAccountContainer = document.getElementById("create-account-container");
  
  if (hasCheckoutParameter()) {
    // If meaningful checkout parameter exists, enable forms and show create account by default
    if (createAccountContainer) {
      createAccountContainer.style.display = "block";
    }

    showAllForms(); // This will show create account form and enable navigation
    showCheckoutLoginForm(); // Ensure create account form is visible

    console.log("Checkout detected - enabling login/register forms with create account as default");
  } else {
    // If no meaningful checkout parameter, hide all forms completely
    if (createAccountContainer) {
      createAccountContainer.style.display = "none";
    }
    
    hideAllForms(); // Hide all forms completely
    console.log("No checkout detected - all forms hidden");
  }
  
  // Initialize toggle functionality regardless (for potential admin access)
  initializeToggleListeners();
}

// Toggle admin access when hidden "O" is clicked
function toggleAdminAccess() {
  const passwordField = document.getElementById("adminPassword");
  const passwordLabel = document.getElementById("adminPasswordLabel");
  const adminContainer = document.getElementById("admin-container");
  
  if (!passwordField) {
    // Show admin password field and hide regular forms
    enablePasswordProtectionField();
  } else {
    // Clean up admin elements
    if (passwordField) passwordField.remove();
    if (passwordLabel) passwordLabel.remove();
    if (adminContainer) adminContainer.remove();
    
    // Also remove any existing admin login form
    const adminForm = document.getElementById("customer_login");
    if (adminForm) adminForm.remove();
    
    // Show the redirect message again
    const messageContainer = document.getElementById("login-message-container");
    if (messageContainer) {
      messageContainer.style.display = "block";
    }
    
    // Return to checkout-based behavior
    if (hasCheckoutParameter()) {
      showAllForms(); // This will show create account form by default
    } else {
      hideAllForms();
    }
  }
}

function showCheckoutLoginForm() {
  // Enable the forms for toggling and show create account form by default
  toggleForm('register-form');
  
  // Set checkout URL in hidden input if it exists
  setCheckoutUrl();
}

// Set the checkout URL in all forms
function setCheckoutUrl() {
  const checkoutUrl = window.location.search.includes('checkout_url=') 
    ? new URLSearchParams(window.location.search).get('checkout_url') 
    : '/';
    
  const checkoutInputs = document.querySelectorAll('input[name="checkout_url"]');
  checkoutInputs.forEach(input => {
    input.value = checkoutUrl;
  });
}

function enableLoginForm(e) {
  let passwordProtection = document.getElementById("adminPassword");
  if (passwordProtection.value === "ipecawaken2023" && e.keyCode == 13) {
    let adminForm = document.getElementById("customer_login");
    if(adminForm == null){
      // Use the admin container or create one
      let adminContainer = document.getElementById("admin-container");
      if (!adminContainer) {
        adminContainer = document.querySelector(".login__inner");
      }
      
      if (adminContainer) {
        adminContainer.insertAdjacentHTML(
          "beforeend",
          '<form method="post" action="/account/login" id="customer_login" accept-charset="UTF-8" data-login-with-shop="true" novalidate="novalidate" class="login__form" data-hs-cf-bound="true">' +
          '<input type="hidden" name="form_type" value="customer_login">' +
          '<input type="hidden" name="utf8" value="✓">' +
          '<div class="MOheader" id="MOmyHeader">' +
          '<p style="text-align:center">' +
          '<input type="button" style="background:#3a3a3a;width:null;height:null;color:#ffffff;" class="btn btn-primary" id="my_button" value="Login at Wordpress" onclick="move()">' +
          '</p>' +
          '<p style="margin-bottom:15px;font-size:20px;text-align:center;"><b>Or Login Via</b></p>' +
          '</div>' +
          '<label for="CustomerEmail">Admin Login</label>' +
          '<input type="email" class="input " name="customer[email]" id="CustomerEmail" autocomplete="email" autocorrect="off" autocapitalize="off">' +
          '<label for="CustomerPassword">Admin Password</label>' +
          '<input type="password" class="input " value="" name="customer[password]" id="CustomerPassword">' +
          '<button type="submit" class="btn btn--primary btn--full">Sign In</button>' +
          '<ul class="login__links ff-body fs-body-100">' +
          '<li><button type="button" class="btn btn--text-link" data-toggle aria-controls="recover-form">Forgot your password?</button></li>' +
          '<li><button type="button" class="btn btn--text-link" data-toggle aria-controls="register-form">Create account</button></li>' +
          '</ul>' +
          '<input type="hidden" name="checkout_url" value="/">' +
          '</form>'
        );
        
        // Re-initialize toggle listeners for dynamically created buttons
        initializeToggleListeners();
      }
    }
  } else {
    let adminForm = document.getElementById("customer_login");
    if (adminForm) {
      adminForm.remove();
    }
  }
}

function enablePasswordProtectionField() {
  // Use the main login container instead of login__main which might be hidden
  let passwordProtectionField = document.querySelector(".login__inner") || document.getElementsByClassName("login__main")[0];
  
  if (!passwordProtectionField) {
    console.error("Could not find container for admin password field");
    return;
  }
  
  // Hide the redirect message when showing password protection
  let messageContainer = document.getElementById("login-message-container");
  if (messageContainer) {
    messageContainer.style.display = "none";
  }
  
  // Hide all regular forms when showing admin access
  hideAllForms();
  
  // Create a temporary container for the admin form if needed
  let adminContainer = document.getElementById("admin-container");
  if (!adminContainer) {
    adminContainer = document.createElement("div");
    adminContainer.id = "admin-container";
    adminContainer.className = "login__main";
    passwordProtectionField.appendChild(adminContainer);
  }
  
  adminContainer.innerHTML = 
    '<label id="adminPasswordLabel" for="adminPassword" style="margin-top: 2em;">Admin Password Protection</label>' +
    '<input id="adminPassword" type="password" class="spr-form-input" onkeyup="enableLoginForm(event)">';
}

// Handle form switching with keyboard navigation
function handleKeyboardNavigation(e) {
  if (e.key === 'Escape') {
    // ESC key returns to default form
    resetToDefaultForm();
  }
}

// Initialize when page loads
document.addEventListener('DOMContentLoaded', function() {
  initializeLoginBehavior();
  
  // Add keyboard navigation
  document.addEventListener('keydown', handleKeyboardNavigation);
  
  // Don't automatically show login form - let initializeLoginBehavior handle it based on checkout parameter
});

// You can also call this function to update the student login link href
function updateStudentLoginLink(newHref) {
  const studentLoginLink = document.getElementById('student-login-link');
  if (studentLoginLink) {
    studentLoginLink.href = newHref;
  }
}

// Utility function to show specific form (can be called externally)
function showForm(formId) {
  toggleForm(formId);
}

// Utility function to reset to default form (create account when checkout detected)
function resetToDefaultForm() {
  if (hasCheckoutParameter()) {
    toggleForm('register-form');
  } else {
    toggleForm('login-form');
  }
}

// Utility function to reset to login form
function resetToLoginForm() {
  toggleForm('login-form');
}

// Utility function to reset to create account form
function resetToCreateAccountForm() {
  toggleForm('register-form');
}

// Debug function to check form visibility states
function debugFormStates() {
  const forms = ['login-form', 'register-form', 'recover-form'];
  forms.forEach(formId => {
    const element = document.getElementById(formId);
    if (element) {
      console.log(`${formId}: display=${element.style.display}, hasHideClass=${element.classList.contains('hide')}, aria-hidden=${element.getAttribute('aria-hidden')}`);
    }
  });
}